import "./TMHBannerStyles.scss";
import React from "react";

export default function TMHBanner({children}) {
    return (
        <div className="wrapper-banner">
            {children}
        </div>
    )
}